module.exports = __webpack_public_path__ + "static/img/20260327001.2bb528f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20260327001.jpg
// module id = +9ni
// module chunks = 0